module.exports = __webpack_public_path__ + "img/img-thailand.990a9fe4.png";